import React from "react";
import { Skeleton } from "@heroui/skeleton";

const CompanyHeaderSkeleton = () => {
  return (
    <div className="flex flex-col sm:flex-row border shadow-md pt-5 pb-4 mt-4 justify-between items-center px-4 rounded-lg bg-company-profile h-250 sm:h-250">
      <div className="flex items-center w-full sm:flex-1">
        <div className="m-4">
          <Skeleton className="h-16 w-16 rounded-full " />
        </div>

        <div className="flex flex-col">
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-4 w-32  mt-2" />
          <Skeleton className="h-4 w-20  mt-2" />
          <Skeleton className="h-4 w-20  mt-2" />
        </div>
      </div>

      <div className="sm:text-right">
        <Skeleton className="h-4 w-32 animate-pulse mb-2" />
        <Skeleton className="h-6 w-48 animate-pulse" />
      </div>
    </div>
  );
};

export default CompanyHeaderSkeleton;
